var path = 'app/reporting/monitoring/view.html';
var html = "<div\n  class=\"view-reporting-monitoring\"\n  ng-include=\"'app/reporting/shared/reportsViewersVisitorsList.html'\"\n></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;